import { gql } from "@apollo/client";

import { MeetingsOverviewMeeting } from "./meetings-overview-meeting-fragment";

export default gql`
  ${MeetingsOverviewMeeting}
  query getUnscheduledMeetingsQuery($forUserId: Int!) {
    unscheduledMeetings: calendar(forUserId: $forUserId, unscheduled: true) {
      totalCount
      edges {
        node {
          id
          meeting {
            ...MeetingsOverviewMeeting
          }
        }
      }
    }
  }
`;
